/**
 * Takes a string, and then returns the shortcode for the video
 */
export const getVideoProviderAndCode = (
  url: string
): { provider: string; code: string } => {
  if (!url) return;

  // youtube
  if (url.includes("youtube")) {
    let shortcode = url.split("/").pop();
    shortcode = shortcode.includes('?') ? shortcode.split('?')[0] : shortcode;
    return {
      provider: "youtube",
      code: shortcode,
    };
  }

  // vimeo
  if (url.includes("vimeo")) {
    const shortcode = url.split("/").pop().split("?")[0];

    return {
      provider: "vimeo",
      code: shortcode,
    };
  }
};
